import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
    UserPoolId: 'us-east-1_Doe5tqGP9',
    ClientId: '8fc2fsju5i8t36e6dkjjaqfg2',
};

const userPool = new CognitoUserPool(poolData);
export default userPool;
